/**
 * 后端接口地址
 */
export const Config = {
  /**
   * 验证用户信息
   */
  validateUser: 'POST /auth/validate',

  /**
   * 获取用户主体信息
   */
  getVendors: 'GET /user/vendor',

  /**
   * 获取用户信息
   */
  getUserInfo: 'GET /user/info',

  /**
   * 更新用户信息
   */
  updateUser: 'POST /user/update',

  /**
   * 获取供应商详情
   */
  getSupplier: 'GET /supplier/{id}',

  /**
   * 绑定供应商信息
   */
  bindSupplier: 'POST /user/bind',

  /**
   * 获取订单列表
   */
  getOrders: 'GET /order/query',

  /**
   * 获取订单详情
   */
  getOrder: 'GET /order/{id}',

  /**
   * 确认订单
   */
  confirmOrder: 'POST /order/confirm',

  /**
   * 退回订单
   */
  returnOrder: 'POST /order/return/{id}',

  /**
   * 确认验收单
   */
  confirmAccept: 'POST /accept/confirm',

  /**
   * 发起验收
   */
  submitAccept: 'POST /accept/submit',

  /**
   * 更新验收信息
   */
  updateAccept: 'POST /accept/update',

  /**
   * 获取验收详情
   */
  getAccept: 'GET /accept/{id}',

  /**
   * 获取供应商验收单列表
   */
  getAcceptList: 'POST /accept/query',

  /**
   * 撤回验收单
   */
  deleteAccept: 'DELETE /supplier-order/accept/withdraw',

  /**
   * 获取微信用户信息
   */
  getWechatUser: 'POST /wechat/user_info'
}
